import { Meridian } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

interface IsAllDayTimeIntervalProps {
  startTime: string;
  startTimeMeridian: Meridian;
  endTime: string;
  endTimeMeridian: Meridian;
}

export const isAllDayTimeInterval = ({
  startTime,
  startTimeMeridian,
  endTime,
  endTimeMeridian,
}: IsAllDayTimeIntervalProps): boolean => {
  return (
    startTime === '12:00' &&
    startTimeMeridian === Meridian.AM &&
    endTime === '11:59' &&
    endTimeMeridian === Meridian.PM
  );
};
